<template>
    <div>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/1.1.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">DESIGN AND R&D CAPABILITY</h3>
                        <p class="swiper-p p AvantGarde">
                            International Design Team - Denmark, Italy, US
                            Phase Gate development process structure
                            Full digital 3D design and engineering
                        </p>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/1.2.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">DESIGN AND R&D CAPABILITY</h3>
                        <p class="swiper-p p AvantGarde">
                            International Design Team - Denmark, Italy, US
                            Phase Gate development process structure
                            Full digital 3D design and engineering
                        </p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">HIGH-END CRAFTSMANSHIP</h3>
                        <p class="swiper-p p AvantGarde">
                            Engineering craft into industrial process
                            High workers stability, >50% above 10 years
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/2.1.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">HIGH-END CRAFTSMANSHIP</h3>
                        <p class="swiper-p p AvantGarde">
                            Engineering craft into industrial process
                            High workers stability, >50% above 10 years
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/2.2.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/3.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">FAST & FLEXIBLE DELIVERY</h3>
                        <p class="swiper-p p AvantGarde">
                            Mix and match, down to 2 weeks factory lead time
                            Mature international supply chain
                            25 years furniture industry experience
                        </p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">QUALITY THINKING</h3>
                        <p class="swiper-p p AvantGarde">
                            Management of line leader responsibility system
                            Industry leading testing lab and accreditation
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/4.1.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">QUALITY THINKING</h3>
                        <p class="swiper-p p AvantGarde">
                            Management of line leader responsibility system
                            Industry leading testing lab and accreditation
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/4.2.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">QUALITY THINKING</h3>
                        <p class="swiper-p p AvantGarde">
                            Management of line leader responsibility system
                            Industry leading testing lab and accreditation
                        </p>
                    </div>
                </div>
                <div class="swiper-img">
                    <img src="../../../assets/images/4.3.jpg" alt="overview_brand_01"/>
                </div>
            </swiper-slide>
        </swiper>
        <swiper class="swiper-box animate opacityIn" ref="mySwiper" :options="swiperOptions1" >
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/5.1.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">CORE COMPETENClES</h3>
                        <p class="swiper-p p AvantGarde">
                            Digital transformation
                            Automated production line
                            Business process optimization
                        </p>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/5.2.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">CORE COMPETENClES</h3>
                        <p class="swiper-p p AvantGarde">
                            Digital transformation
                            Automated production line
                            Business process optimization
                        </p>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide >
                <div class="swiper-img">
                    <img src="../../../assets/images/5.3.jpg" alt="overview_brand_01"/>
                </div>
                <div class="slide">
                    <div class="slide-inner animate fadeInUp">
                        <h3 class="swiper-title AvantGarde">CORE COMPETENClES</h3>
                        <p class="swiper-p p AvantGarde">
                            Digital transformation
                            Automated production line
                            Business process optimization
                        </p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    export default {
        name: 'CompetenciesBanner',
        data() {
            return {
                swiperOptions1: {
                    pagination: '.swiper-pagination-1',
                    paginationClickable :true,
                    autoplayDisableOnInteraction : false,
                    loop: true,
                    autoplay : 3000,
                    speed: 1000,
                    effect : 'fade',
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use 'styles/common' as *;
    .swiper-box {
        margin: 10vw 0 0 0;
    }
    .slide {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40%;
        background: #f4f3ee;
        @include respond-to() {
            display: block;
            width: 100%;
        }
    }
    .swiper-title {
        margin-bottom: 2vw;
    }
    .slide-inner {
        width:80%;
        @include respond-to() {
            padding: 10vw;
            width: 100%;
            box-sizing: border-box;
        }
    }
    .swiper-img {
        width: 60%;
        @include respond-to() {
            width: 100%;
        }
    }
    .swiper-img img {
        width: 100%;
    }
    .swiper-container-fade .swiper-slide{
        opacity:0!important;
        display: flex;
        @include respond-to() {
            display: block;
        }
    }
    .swiper-container-fade .swiper-slide-active{opacity:1!important;}
</style>
